export default __webpack_public_path__ + "static/media/0x71b821aa52a49f32eed535fca6eb5aa130085978.c25a78fb.png";